// See: https://github.com/kbaum/browser-timezone-rails/blob/28c1e844046f054e658680143291748d3fb7cbed/app/assets/javascripts/browser_timezone_rails/set_time_zone.js.erb

document.cookie = `browser.timezone=${encodeURIComponent(Intl.DateTimeFormat().resolvedOptions().timeZone)};path=/;max-age=${60 * 60 * 24 * 365.24225};SameSite=Lax${document.location.protocol === 'https:' ? ';secure' : ''}`;
